/** @format */

export const KEY_APP_NAME = "Brugnano 110";
export const KEY_ASSISTANCE_MAIL = "produzione@infcom.it";
